import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
var AreaOfSupportSection = function AreaOfSupportSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "px-4 pb-[100px] md:max-w-[1152px] md:mx-auto md:px-0 md:pb-[104px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row-reverse md:justify-between md:items-center gap-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-[340px] bg-[#F4F9FE] flex items-center justify-center rounded-2xl md:h-[565px] md:w-[536px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/map.svg",
    width: "260",
    height: "214",
    alt: tLong("about_us/map_alt", {
      ns: "web_common"
    }),
    loading: "lazy",
    className: "lg:w-[415px] lg:h-[430px]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-start text-2xl font-bold md:text-[40px] md:leading-[56px] md:max-w-[475px]"
  }, tShort("about_us/area_of_support_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#576678] text-base font-regular text-start leading-6 md:text-2xl md:leading-10 md:max-w-[465px]"
  }, tLong("about_us/area_of_support_subtitle", {
    ns: "web_common"
  }))))));
};
export default AreaOfSupportSection;